import React, { useState, Fragment } from 'react';

import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { makeStyles } from '@material-ui/core/styles';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Button from 'components/CustomButtons/Button.js';
import { Add, Assignment, Edit } from '@material-ui/icons';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import VisibilityIcon from '@material-ui/icons/Visibility';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';

import { Link } from 'react-router-dom';
import { nPercent, currency } from 'hooks/Pipe';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import SaleOrderDetail from '../SaleOrder/SaleOrderDetail';
import { useModal } from 'hooks/useModal';
import EditModal from './EditModal';

const stylesCard = {
  ...styles,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
  },
};

const useStyles = makeStyles(stylesCard);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 120 },
  { Header: 'ID', accessor: 'order', width: 100, align: 'center' },
  { Header: 'Comentario', accessor: 'comments', width: 200 },
  { Header: 'Tipo', accessor: 'U_SYP_MDTD', width: 100 },
  { Header: 'Serie', accessor: 'U_SYP_MDSD', width: 120 },
  { Header: 'Número', accessor: 'U_SYP_MDCD', width: 150 },
  { Header: 'Fecha', accessor: 'date', width: 120, align: 'center' },
  { Header: 'Zona', accessor: 'sede', width: 150 },
  { Header: 'Vendedor', accessor: 'seller' },
  { Header: 'Cliente', accessor: 'CardCode', width: 120 },
  { Header: 'Razón social', accessor: 'CardName' },
  { Header: 'Estado', accessor: 'state_migrate', width: 100, align: 'right' },
  { Header: 'Cantidad', accessor: 'units', width: 100, align: 'center' },
  { Header: 'Saldo', accessor: 'saldo', width: 80, align: 'right' },
  { Header: 'Término pago', accessor: 'paymentTerm', width: 130 },
  { Header: 'Doc. referencia', accessor: 'document', width: 190 },
  { Header: 'Importe', accessor: 'total_order', width: 100, align: 'right' },
  { Header: 'Margen', accessor: 'margen', width: 100, align: 'right' },
  { Header: '% Desc', accessor: 'digitate_discount', width: 80, align: 'right' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function NCredito(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();
  const { title, permission } = props;

  const [editModel, setEditModalOpen] = useModal();
  const [nCredits, setNCredits] = useState([]);
  const [open, setOpen] = useState(false);
  const [idOrder, setIdOrder] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  async function listNCredits(filter) {
    const search = { ...filter };
    setDataLoading(true);
    if (search.state) {
      search.state_migrate = search.state;
      delete search.state;
    }
    let response = await wsFindBy('sale/credit-note', search);
    setDataLoading(false);
    if (response.success) setNCredits(response.data);
  }

  return (
    <Fragment>
      <Toasty action={notify} />

      <EditModal
        model={editModel}
        setOpen={setEditModalOpen}
        showNotify={showNotify}
        setCreditNotes={setNCredits}
      />

      {open ? (
        <ModalFull title="Detalles" open={open} setOpen={setOpen}>
          <SaleOrderDetail entity="sale/credit-note" idOrder={idOrder} typeDetail="NC" />
        </ModalFull>
      ) : undefined}
      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={permission.store}
            component={
              <CardIcon color={props.themeContext.buttonColor}>
                <Assignment style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <Link to="0">
              <CardIcon pointer="true" color="success">
                <Add style={{ color: 'white' }} />
              </CardIcon>
            </Link>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>
            <span>Listado de notas de crédito {title} {dataLoading && <LoadingSpinner />}</span>
          </h4>
        </CardHeader>

        <CardBody>
          <FilterCustom
            getFilter={listNCredits}
            zone
            dateRange
            seller
            state
            optionValues={['X', 'F', 'D', 'A']}
            nameOptions={['Procesando', 'Finalizado', 'Borrador', 'Anulado']}
          />

          <ReactTable
            excelName={`Notas-credito-${title}`}
            formatDate="DD-MM-YYYY"
            defaultWidth={2500}
            columns={columns}
            data={nCredits.map((order, i) => {
              let state;
              switch (order.state_migrate) {
                case 'X':
                  state = 'Procesando';
                  break;
                case 'F':
                  state = 'Finalizado';
                  break;
                case 'D':
                  state = 'Borrador';
                  break;
                case 'A':
                  state = 'Anulado';
                  break;
                default:
                  state = 'Otros';
                  break;
              }
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    {/* <AllowedGuard permission={permission.show}> */}
                    <Button
                      justIcon
                      round
                      simple
                      onClick={() => {
                        setOpen(!open);
                        setIdOrder(order.id);
                      }}
                      color={props.themeContext.buttonColor}
                    >
                      <VisibilityIcon />
                    </Button>
                    {/* </AllowedGuard> */}
                    <AllowedGuard permission={permission.update}>
                      <Button
                        justIcon
                        round
                        simple
                        onClick={() => setEditModalOpen(order)}
                        color="warning"
                      >
                        <Edit />
                      </Button>
                    </AllowedGuard>
                  </div>
                ),
                order: order.id.toString(),
                comments: order.comment || order.comments || '',
                U_SYP_MDTD: order.U_SYP_MDTD === '07' ? 'Nota crédito' : order.U_SYP_MDTD,
                U_SYP_MDSD: order.U_SYP_MDSD,
                U_SYP_MDCD: order.U_SYP_MDCD,
                date: order.created_at,
                sede: `${order.base_zone_code || ''} - ${order.base_zone_description || ''}`,
                seller: `${order.SlpCode || ''} - ${order.SlpName || ''}`,
                CardCode: order.CardCode,
                CardName: order.CardName,
                state_migrate: state,
                units: order.units,
                saldo: currency(order.balance_sap),
                paymentTerm: order.PymntGroup,
                document: `${order.TipoDocumentoRef || ''} - ${order.U_SYP_MDSO || ''} - ${
                  order.U_SYP_MDCO || ''
                }`,
                total_order: currency(order.total_order),
                margen: currency(order.margin_amount),
                discount: nPercent(order.discount) + ' %',
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </Fragment>
  );
});
